import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloud = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "defenseInDepth",
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16340",
		"data-name": "Group 16340",
		transform: "translate(3.333 8.333)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12365",
				"data-name": "Path 12365",
				d: "M9.207,11.78a8.314,8.314,0,0,0,1.127,16.553H28.667a6.667,6.667,0,0,0,0-13.333,10,10,0,0,0-19.46-3.22Z",
				transform: "translate(-2 -5)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12366",
				"data-name": "Path 12366",
				d: "M18,13H11.33",
				transform: "translate(4.22 0.333)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12367",
				"data-name": "Path 12367",
				d: "M15.33,15.067V13",
				transform: "translate(6.887 0.333)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12368",
				"data-name": "Path 12368",
				d: "M13.33,15.067V13",
				transform: "translate(5.553 0.333)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12369",
				"data-name": "Path 12369",
				d: "M12.46,12.318a2.222,2.222,0,1,1-3.142,0,2.222,2.222,0,0,1,3.142,0",
				transform: "translate(2.445 -0.555)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12370",
		"data-name": "Path 12370",
		d: "M0,0H40V40H0Z",
		fill: "none"
	})]
});
export default SvgCloud;
